import type { UnlikelyMedia } from "@unlikelystudio/commerce-connector"

import type { Nullish } from "~/@types/generics"
import { getMarket } from "~/lib/i18n/utils/get-i18n"
import { serializeShopifyMedia } from "~/lib/shopify/serializers/serialize-shopify-media"
import { serializeShopifyImages } from "~/components/ui/Image/_data/serializer"

export function getMediasByMarketName(medias: UnlikelyMedia[], locale: Nullish<string>) {
  if (!locale) {
    return medias
  }

  const marketName = getMarket(locale)

  return medias.filter((media) => {
    if (media && "mediaContentType" in media) {
      let [serializedMedia] = serializeShopifyMedia([media])

      return serializedMedia && (serializedMedia?.alt?.length === 0 || serializedMedia?.alt?.includes(marketName))
    }

    let [serializedImage] = serializeShopifyImages([media])
    return serializedImage && (serializedImage?.alt?.length === 0 || serializedImage?.alt?.includes(marketName))
  })
}
